var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHomeWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.64162 2.12613C10.9923 0.944609 13.0087 0.944612 14.3594 2.12613L20.7208 7.69086C21.706 8.55261 22.271 9.79772 22.271 11.1066V19.1672C22.271 21.1459 20.667 22.75 18.6883 22.75H5.31273C3.33403 22.75 1.72998 21.1459 1.72998 19.1672V11.1066C1.72998 9.79772 2.29508 8.55261 3.2802 7.69086L9.64162 2.12613ZM13.4159 3.20477C12.6054 2.49586 11.3956 2.49586 10.5852 3.20477L4.22375 8.7695C3.54972 9.35912 3.16308 10.211 3.16308 11.1066V19.1672C3.16308 20.3545 4.12551 21.3169 5.31273 21.3169H18.6883C19.8755 21.3169 20.838 20.3545 20.838 19.1672V11.1066C20.838 10.211 20.4513 9.35912 19.7773 8.76951L13.4159 3.20477Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.25 16.8635C9.25 16.4493 9.58579 16.1135 10 16.1135H14C14.4142 16.1135 14.75 16.4493 14.75 16.8635C14.75 17.2778 14.4142 17.6135 14 17.6135H10C9.58579 17.6135 9.25 17.2778 9.25 16.8635Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeWhite);
export default __webpack_public_path__ + "static/media/home_white.40a66468173416b76289c9604f62af34.svg";
export { ForwardRef as ReactComponent };